import Layout from "@/components/layout/layout";
import TourAssign from "../components/tour/tour-assign";
const TourAssignPage = () => {
  return (
    <div>
      <Layout>
        <TourAssign />
      </Layout>
    </div>
  );
};

export default TourAssignPage;
